module.exports = __webpack_public_path__ + "img/mailchimp_logo.bb181892.png";